import React from "react";
import "./evereg.css";
import Regcard from "./everegprops";
import Logo from "../../atrimages/logo.jpg";

export default function Everegister() {
  return (
    <div class="regCard">
      <h1>Register Here....</h1>
      <Regcard
        logo={Logo}
        isfor="Passes for Atri Students"
        desclink="Click here to Book passes for Cultural Night on 17th June"
      />
      <Regcard
        logo="https://media.istockphoto.com/id/513534403/vector/school-children.jpg?s=612x612&w=0&k=20&c=GWpBeFM2GGVLgknCFd79NZq0v5NtEcmULRhmx7zKZeI="
        isfor="Passes for Other College Students"
        desclink="Click here to Book passes for Cultural Night on 17th June"
      />
      <Regcard
        logo={Logo}
        isfor="Event Registration for ATRI Students"
        desclink="click here to register for Techno-literary-cultural events "
      />
      <Regcard
        logo="https://media.istockphoto.com/id/513534403/vector/school-children.jpg?s=612x612&w=0&k=20&c=GWpBeFM2GGVLgknCFd79NZq0v5NtEcmULRhmx7zKZeI="
        isfor="Event Registration Other College Students "
        desclink="Click here to register for Techno-literary-cultural events "
      />
    </div>
  );
}
